import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { BagActionTypes, MinicartActionTypes } from '@state/features/common.types';
import { createBrowserHistory } from 'history';
import ReduxQuerySync from 'redux-query-sync';
import { applyScrollbarWidth } from '@common/scripts/services/breakpointerService';
import customEventBus from '../scripts/libs/eventBus';
import accordionstepsSlice from './features/accordion.slice';
import { accountRootReducer, accountRootSaga } from './features/account.index';
import { aftercareReducer, aftercareRootSaga } from './features/aftercare.index';
import { bagRootReducer, bagRootSaga } from './features/bag.index';
import { checkoutRootReducer, checkoutRootSaga } from './features/checkout.index';
import { rootReducer, rootSaga } from './features/listing.index';
import { minicartRootReducer, minicartRootSaga } from './features/minicart.index';
import { searchReducer } from './features/search.index';
import searchSaga from './features/search.saga';
import { storelocatorReducer, storelocatorRootSaga } from './features/storelocator.index';
import sagaMiddleware from './middlewares/saga.middleware';
const middleware = [...getDefaultMiddleware({ thunk: true }), sagaMiddleware];
const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('ib-state', serializedState);
    }
    catch (e) {
        // Ignore write errors;
    }
};
const basename = document.domain === 'localhost' || document.domain.indexOf('devserver.moncler.local') > -1 ? '/app.html' : '/';
export const history = createBrowserHistory({ basename: basename });
//check this https://github.com/reduxjs/redux-toolkit/issues/282
const configureCatalogStore = () => {
    const store = configureStore({
        reducer: rootReducer,
        devTools: { name: 'PLP/PDP' },
        middleware,
    });
    sagaMiddleware.run(rootSaga);
    store.subscribe(() => saveState(store.getState()));
    return store;
};
const configureSearchStore = () => {
    const store = configureStore({
        reducer: searchReducer,
        devTools: { name: 'Search' },
        middleware,
    });
    sagaMiddleware.run(searchSaga);
    store.subscribe(() => saveState(store.getState()));
    return store;
};
const configureMinicartStore = () => {
    const store = configureStore({
        reducer: minicartRootReducer,
        devTools: { name: 'Minicart' },
        middleware,
    });
    sagaMiddleware.run(minicartRootSaga);
    store.subscribe(() => {
        saveState(store.getState());
    });
    // open minicart on MBM finish page
    const urlParams = new URLSearchParams(location.search);
    const pli = urlParams.get('pli');
    if (pli) {
        console.info('pli presente quindi applyScrollbarWidth');
        applyScrollbarWidth();
        setTimeout(() => {
            store.dispatch({
                type: MinicartActionTypes.FETCH_MINICART_AFTER_UPDATE,
                payload: {
                    pid: pli,
                },
            });
        }, 500);
    }
    customEventBus.on('minicart:update', (data) => {
        // console.info('minicart:update for FETCH_MINICART_AFTER_UPDATE');
        if (data === null || data === void 0 ? void 0 : data.fromAddToBag) {
            store.dispatch({
                type: MinicartActionTypes.FETCH_MINICART_AFTER_UPDATE,
                payload: {
                    pid: data === null || data === void 0 ? void 0 : data.pid,
                },
            });
        }
        else {
            // console.info('minicart:update for UPDATE_MINICART');
            store.dispatch({
                type: MinicartActionTypes.UPDATE_MINICART,
                payload: {
                    fromBag: true,
                },
            });
        }
    });
    return store;
};
const configureBagStore = () => {
    const store = configureStore({
        reducer: bagRootReducer,
        devTools: { name: 'Bag' },
        middleware,
    });
    sagaMiddleware.run(bagRootSaga);
    store.subscribe(() => {
        saveState(store.getState());
    });
    customEventBus.on('bag:update', (data) => {
        console.info('bag:update received');
        store.dispatch({
            type: BagActionTypes.FETCH_BAG,
            payload: {
                fromMinicart: data === null || data === void 0 ? void 0 : data.fromMinicart,
            },
        });
    });
    return store;
};
const configureCheckoutStore = () => {
    const store = configureStore({
        reducer: checkoutRootReducer,
        devTools: { name: 'Checkout' },
        middleware,
    });
    sagaMiddleware.run(checkoutRootSaga);
    store.subscribe(() => {
        saveState(store.getState());
    });
    return store;
};
const configureAccountStore = () => {
    const store = configureStore({
        reducer: accountRootReducer,
        devTools: { name: 'Account' },
        middleware,
        enhancers: [
            ReduxQuerySync.enhancer({
                params: {
                    step: {
                        selector: (state) => state.step.step,
                        action: (newStep) => {
                            return accordionstepsSlice.actions.updateStep(newStep || 'orderNumber');
                        },
                    },
                },
                initialTruth: 'location',
                replaceState: true,
            }),
        ],
    });
    sagaMiddleware.run(accountRootSaga);
    store.subscribe(() => {
        saveState(store.getState());
    });
    return store;
};
const configureAfterCareStore = () => {
    const store = configureStore({
        reducer: aftercareReducer,
        devTools: { name: 'Aftercare' },
        middleware,
        enhancers: [
            ReduxQuerySync.enhancer({
                params: {
                    step: {
                        selector: (state) => state.step.step,
                        action: (newStep) => {
                            console.log('updating step to ' + newStep);
                            return accordionstepsSlice.actions.updateStep(newStep || 'customer');
                        },
                    },
                },
                initialTruth: 'location',
                replaceState: true,
            }),
        ],
    });
    sagaMiddleware.run(aftercareRootSaga);
    store.subscribe(() => {
        saveState(store.getState());
    });
    return store;
};
const configureStoreLocatorStore = () => {
    const store = configureStore({
        reducer: storelocatorReducer,
        devTools: { name: 'StoreLocator' },
        middleware,
    });
    sagaMiddleware.run(storelocatorRootSaga);
    store.subscribe(() => saveState(store.getState()));
    return store;
};
export { configureAccountStore, configureAfterCareStore, configureBagStore, configureCatalogStore, configureCheckoutStore, configureMinicartStore, configureSearchStore, 
//configureUiStore,
configureStoreLocatorStore, };
